<template>
  <gs-modal
    v-loading="loading"
    v-model="visible"
    :before-close="beforeClose"
    :title="isEdit?'编辑':'新建'"
    class="my-test-class"
    @close="close"
    @confirm="handleConfirm"
  >
    <gs-form :model="form">
      <fieldset>
        <legend>范围</legend>
        <div style="padding:10px">
          <gs-checkbox v-model="form.isWeek">每周</gs-checkbox>
          <gs-checkbox
            :disabled="form.isWeek"
            v-model="form.isYear"
          >每年</gs-checkbox>
        </div>
        <gs-date-picker
          v-model="form.date"
          :disabled="form.isWeek"
          :default-time="[form.defaultTime, form.defaultTime1]"
          style="padding:10px"
          type="date-range"
        />
      </fieldset>
      <fieldset>
        <legend>时间</legend>
        <div style="padding:10px">
          <gs-radio-group v-model="timeType">
            <gs-radio :label="1">指定时间段</gs-radio>
            <gs-radio :label="2">全天开启</gs-radio>
            <gs-radio
              :label="3"
              :disabled="form.isWeek"
            >全天关闭</gs-radio>
          </gs-radio-group>
        </div>
        <gs-time-picker
          :disabled="timeType!==1"
          v-model="form.startTime"
          format="HH:mm"
          @change="compareValue"
        />
        <gs-time-picker
          :disabled="timeType!==1"
          v-model="form.stopTime"
          format="HH:mm"
          @change="compareValue"
        />
      </fieldset>
      <fieldset>
        <legend>有效日</legend>
        <gs-checkbox
          :indeterminate="isIndeterminate"
          v-model="checkAll"
          class="custom-label"
          @change="handleCheckAllChange"
        >全选</gs-checkbox>
        <gs-checkbox-group
          v-model="checkedCities"
          @change="handleCheckedCitiesChange"
        >
          <gs-checkbox
            v-for="city in cities"
            :label="city"
            :key="city"
            style="margin:10px"
          >{{ city }}</gs-checkbox>
        </gs-checkbox-group>
      </fieldset>
    </gs-form>
  </gs-modal>
</template>

<script type="text/ecmascript-6">
import moment from 'moment'
import eventBus from './vue.js'
export default {
  components: {

  },
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    timeChartList: {
      type: Array,
      default: () => {
        return []
      }
    }
  },
  data () {
    return {
      loading: false,
      checkAll: true,
      checkedCities: [],
      cities: ['星期一', '星期二', '星期三', '星期四', '星期五', '星期六', '星期日'],
      isIndeterminate: true,
      timeType: 1,
      form: {
        isWeek: true,
        date: '',
        isYear: false,
        date1: '',
        formDate: moment(),
        toDate: moment(),
        startTime: moment(),
        stopTime: moment()
      },
      isEdit: false
    }
  },
  watch: {
    visible () {
      if (!this.visible) {
        this.form = {
          isWeek: true,
          date: [moment(), moment()],
          isYear: false,
          formDate: moment(),
          toDate: moment(),
          startTime: moment(),
          stopTime: moment()
        }
        this.isEdit = false
        this.checkedCities = []
      } else {
        console.log(this.timeChartList)
      }
    },
    timeChartList () {
      eventBus.$emit('timeChartList', this.timeChartList)
    }
  },
  created () {

  },
  mounted () {
    eventBus.$on('reSetList', () => {
      this.timeChartList = []
    })
    eventBus.$on('editTimeChart', (data) => {
      this.isEdit = true
      this.form = {
        id: data.id ? data.id : Math.random(),
        isWeek: true,
        date: [moment(data.formDate, 'YYYY-MM-DD'), moment(data.toDate, 'YYYY-MM-DD')],
        isYear: false,
        date1: '',
        formDate: moment(data.formDate, 'YYYY-MM-DD'),
        toDate: moment(data.toDate, 'YYYY-MM-DD'),
        startTime: moment(data.startTime, 'HH:mm'),
        stopTime: moment(data.stopTime, 'HH:mm')
      }
      let weekArray = data.weekDays.split('')
      // for (let i = 0; i < weekArray.length; i++) {
      if (weekArray[0] === 'M') {
        this.checkedCities.push('星期一')
      }
      if (weekArray[1] === 'T') {
        this.checkedCities.push('星期二')
      }
      if (weekArray[2] === 'W') {
        this.checkedCities.push('星期三')
      }
      if (weekArray[3] === 'T') {
        this.checkedCities.push('星期四')
      }
      if (weekArray[4] === 'F') {
        this.checkedCities.push('星期五')
      }
      if (weekArray[5] === 'S') {
        this.checkedCities.push('星期六')
      }
      if (weekArray[6] === 'S') {
        this.checkedCities.push('星期日')
      }
      // }
      this.timeType = data.isTime
      switch (data.period) {
        case 'week':
          this.form.isWeek = true
          this.form.isYear = false
          break
        case 'year':
          this.form.isWeek = false
          this.form.isYear = true
          break
        case 'day':
          this.form.isWeek = false
          this.form.isYear = false
          break
        default:
          break
      }
      if (this.timeChartList.length === 0) {
        this.timeChartList.push(this.form)
      }
    })
  },
  methods: {
    handleCheckAllChange (event) {
      this.checkedCities = event.target.checked ? timeOptions : []
      this.isIndeterminate = false
    },
    handleCheckedCitiesChange (value) {
      let checkedCount = value.length
      this.checkAll = checkedCount > 0
      this.isIndeterminate = checkedCount > 0 && checkedCount < this.cities.length
    },
    beforeClose () {
     /* this.form = {
        isWeek: true,
        date: '',
        isYear: false
      }*/
      this.isEdit = false
      this.checkedCities = []
      this.$emit('closeNewAdd', true)
    },
    close () {
      this.form = {
        isWeek: true,
        date: '',
        isYear: false
      }
      this.isEdit = false
      this.checkedCities = []
      this.$emit('closeNewAdd', true)
    },
    handleConfirm () {
      this.form.formDate = this.form.date[0]
      this.form.toDate = this.form.date[1]
      let textString = ['_', '_', '_', '_', '_', '_', '_']
      this.checkedCities.forEach(e => {
        switch (e) {
          case '星期一':
            textString[0] = 'M'
            break
          case '星期二':
            textString[1] = 'T'
            break
          case '星期三':
            textString[2] = 'W'
            break
          case '星期四':
            textString[3] = 'T'
            break
          case '星期五':
            textString[4] = 'F'
            break
          case '星期六':
            textString[5] = 'S'
            break
          case '星期日':
            textString[6] = 'S'
            break
          default:
            break
        }
      })
      textString = textString.join('')
      if (this.form.id) {
        for (let i = 0; i < this.timeChartList.length; i++) {
          if (this.timeChartList[i].id === this.form.id) {
            // delete e
            this.timeChartList.splice(i, 1)
            let from = ''
            let to = ''
            let startTime = ''
            let endTime = ''
            if (this.form.isYear && !this.form.isWeek) {
              from = '****-' + moment(this.form.formDate).format('YYYY-MM-DD').substr(5, 10)
              to = '****-' + moment(this.form.toDate).format('YYYY-MM-DD').substr(5, 10)
            } else if (this.form.isWeek) {
              from = '-'
              to = '-'
            } else {
              from = moment(this.form.formDate).format('YYYY-MM-DD')
              to = moment(this.form.toDate).format('YYYY-MM-DD')
            }
            switch (this.timeType) {
              case 1:
                startTime = moment(this.form.startTime).format('HH:mm')
                endTime = moment(this.form.stopTime).format('HH:mm')
                break
              case 2:
                startTime = '00:00'
                endTime = '24:00'
                break
              case 3:
                startTime = '00:00'
                endTime = '00:00'
                break
              default:
                break
            }
            let period = ''
            if (this.form.isWeek && !this.form.isYear) {
              period = 'week'
            } else if (!this.form.isWeek && this.form.isYear) {
              period = 'year'
            } else {
              period = 'day'
            }

            this.timeChartList.push({
              id: this.form.id,
              formDate: from,
              toDate: to,
              startTime: startTime,
              stopTime: endTime,
              weekDays: textString,
              isTime: this.timeType,
              period: period
            })
          }
        }
      } else {
        let from = ''
        let to = ''
        let startTime = ''
        let endTime = ''
        if (this.form.isYear && !this.form.isWeek) {
          from = '****-' + moment(this.form.formDate).format('YYYY-MM-DD').substr(5, 10)
          to = '****-' + moment(this.form.toDate).format('YYYY-MM-DD').substr(5, 10)
        } else if (this.form.isWeek) {
          from = '-'
          to = '-'
        } else {
          from = moment(this.form.formDate).format('YYYY-MM-DD')
          to = moment(this.form.toDate).format('YYYY-MM-DD')
        }
        switch (this.timeType) {
          case 1:
            startTime = moment(this.form.startTime).format('HH:mm')
            endTime = moment(this.form.stopTime).format('HH:mm')
            break
          case 2:
            startTime = '00:00'
            endTime = '24:00'
            break
          case 3:
            startTime = '00:00'
            endTime = '00:00'
            break
          default:
            break
        }
        let period = ''
        if (this.form.isWeek && !this.form.isYear) {
          period = 'week'
        } else if (!this.form.isWeek && this.form.isYear) {
          period = 'year'
        } else {
          period = 'day'
        }
        this.timeChartList.push({
          id: 'id' + moment().format('HH:mm:ss'),
          formDate: from,
          toDate: to,
          startTime: startTime,
          stopTime: endTime,
          weekDays: textString,
          isTime: this.timeType,
          period: period
        })
      }
      this.$emit('closeNewAdd', this.timeChartList)
    },
    compareValue () {
      if (this.form.startTime && this.form.stopTime) {
        let start = moment(this.form.startTime)
        let end = moment(this.form.stopTime)
        let startHour = start.hour()
        let endHour = end.hour()
        let startMin = start.minute()
        let endMin = end.minute()
        let finalstart = startHour * 60 * 60 + startMin * 60
        let finalend = endHour * 60 * 60 + endMin * 60
        if (finalstart > finalend) {
          this.$Message.error('您选择的时间有误')
          this.form.startTime = moment()
          this.form.stopTime = moment()
          return false
        }
      }
    }

  }
}
</script>




// WEBPACK FOOTER //
// src/components/timeChart/timeChartNewAdd.vue